import React from "react";

const NoRecord = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_504_30600)">
        <path
          d="M48.5215 39.9595C48.959 40.7456 49.8374 41.1301 50.738 41.125C52.2693 41.1182 53.4963 42.4221 53.3647 43.979C53.2485 45.3582 52.0044 46.375 50.6201 46.375H42V47.25H6.12498C4.62791 47.25 3.42479 45.9973 3.5034 44.4849C3.5786 43.0647 4.85179 42 6.27366 42H6.99998C8.06297 42 8.90379 41.0532 8.72606 39.9561C8.58592 39.0964 7.77757 38.5 6.90599 38.5H2.62498C1.12791 38.5 -0.0752122 37.2473 0.00340108 35.7349C0.0785966 34.3147 1.35179 33.25 2.77366 33.25H8.31248C9.52073 33.25 10.5 32.2708 10.5 31.0625C10.5 29.8542 9.52073 28.875 8.31248 28.875C7.10423 28.875 6.12498 27.8958 6.12498 26.6875C6.12498 25.4792 7.10423 24.5 8.31248 24.5H15.75V18.375H9.18748C7.44261 18.375 6.03612 16.9138 6.13011 15.1484C6.21556 13.4924 7.70237 12.25 9.36009 12.25H15.75V8.75H49.4375C51.1824 8.75 52.5888 10.2112 52.4949 11.9766C52.4094 13.6326 50.9226 14.875 49.2649 14.875H46.8125C45.0676 14.875 43.6611 16.3362 43.7551 18.1016C43.8406 19.7576 45.3274 21 46.9851 21H49C50.5552 21 51.7942 22.3535 51.6062 23.9446C51.449 25.2656 50.2527 26.1953 48.9248 26.2517C47.8772 26.2944 47.0688 27.26 47.2842 28.3555C47.4499 29.186 48.2326 29.75 49.0786 29.75H52.9375C54.6824 29.75 56.0888 31.2112 55.9949 32.9766C55.9094 34.6326 54.4226 35.875 52.7649 35.875H50.75C48.8325 35.875 47.3952 37.9309 48.5215 39.9595ZM2.18748 28.875C3.39573 28.875 4.37498 27.8958 4.37498 26.6875C4.37498 25.4792 3.39573 24.5 2.18748 24.5C0.979231 24.5 -1.6893e-05 25.4792 -1.6893e-05 26.6875C-1.6893e-05 27.8958 0.979231 28.875 2.18748 28.875ZM2.18748 28.875C3.39573 28.875 4.37498 27.8958 4.37498 26.6875C4.37498 25.4792 3.39573 24.5 2.18748 24.5C0.979231 24.5 -1.6893e-05 25.4792 -1.6893e-05 26.6875C-1.6893e-05 27.8958 0.979231 28.875 2.18748 28.875Z"
          fill="#EFF6FE"
        ></path>
        <path d="M12.8 49V7H34.7516L45.2 17.4484V49H12.8Z" fill="white"></path>
        <path
          d="M33.6747 7.60002C34.2052 7.60002 34.7139 7.81074 35.0889 8.18581L44.0142 17.111C44.3892 17.4861 44.6 17.9948 44.6 18.5253V46.4C44.6 47.5046 43.7045 48.4 42.6 48.4H15.4C14.2954 48.4 13.4 47.5046 13.4 46.4V9.60002C13.4 8.49545 14.2954 7.60002 15.4 7.60002H33.6747ZM35.5857 6.98581C35.2107 6.61074 34.702 6.40002 34.1715 6.40002H14.2C13.0954 6.40002 12.2 7.29545 12.2 8.40002V47.6C12.2 48.7046 13.0954 49.6 14.2 49.6H43.8C44.9045 49.6 45.8 48.7046 45.8 47.6V18.0285C45.8 17.498 45.5892 16.9893 45.2142 16.6142L35.5857 6.98581Z"
          fill="#E2EAF3"
        ></path>
        <path
          d="M34.4 17.8V7H34.7516L45.2 17.4484V17.8H34.4Z"
          fill="white"
        ></path>
        <path
          d="M35 8.09682L44.1032 17.2H37C35.8955 17.2 35 16.3046 35 15.2V8.09682ZM35 6.40002H33.8V16.4C33.8 17.5046 34.6955 18.4 35.8 18.4H45.8V17.2L35 6.40002Z"
          fill="#E2EAF3"
        ></path>
        <path
          d="M32.6 29.4028L29 32.8L34.4648 38.8H38.6V35.2L32.6 29.4028Z"
          fill="#7AADF0"
        ></path>
        <path
          d="M36.2 22C35.5635 22 34.9531 22.2529 34.503 22.7029C34.0529 23.153 33.8 23.7635 33.8 24.4C33.8 25.0365 34.0529 25.647 34.503 26.0971C34.9531 26.5471 35.5635 26.8 36.2 26.8C36.8365 26.8 37.447 26.5471 37.8971 26.0971C38.3472 25.647 38.6 25.0365 38.6 24.4C38.6 23.7635 38.3472 23.153 37.8971 22.7029C37.447 22.2529 36.8365 22 36.2 22ZM36.2 38.8H19.4V34L25.4 28L36.2 38.8Z"
          fill="#B5DEFF"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_504_30600">
          <rect width="56" height="56" fill="white"></rect>
        </clipPath>
      </defs>
    </svg>
  );
};

export default NoRecord;
